import {
  initialState,
  Actions,
  State,
  EDIT_PLAN,
  EDIT_PLAN_SUCCESS,
  EDIT_PLAN_ERROR,
  RESET_EDIT_PLAN,
} from "../../types/plan/edit";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case EDIT_PLAN:
      return {
        ...state,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case EDIT_PLAN_SUCCESS:
      return {
        ...state,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case EDIT_PLAN_ERROR:
      return {
        ...state,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case RESET_EDIT_PLAN:
      return initialState;
    default:
      return state;
  }
};

export default reducers;
